import { useCallback } from 'react';

import useAsyncRequest from '../../../hooks/useAsyncRequest';
import { getReleaseGroups } from '../../api/organization';
import useSlug from '../../hooks/useSlug';

const useReleaseGroups = ({ isPublic, search }: { isPublic: boolean; search?: string }) => {
  const slug = useSlug();
  const getReleaseGroupsReq = useCallback(() => getReleaseGroups({ slug, search, isPublic }), [slug, search, isPublic]);
  const { value: releaseGroups, errors, isLoading } = useAsyncRequest(getReleaseGroupsReq);

  return { releaseGroups, errors, isLoading };
};

export default useReleaseGroups;
